module.exports = __webpack_public_path__ + "media/images/athletes/1404-af36b837edb9a3cd27251fcc2afe382a.png";